module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    ref: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        _vm.updateValue($event.target.value)
      }
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-edb6b47e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-cleave/src/Cleave.vue
// module id = 1369
// module chunks = 1